import { Link } from "react-router-dom";

const AboutPreview = () => {
  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center">
          {/* Image Section */}
          <div className="lg:w-1/2 mb-12 lg:mb-0">
            <div className="relative float-right">
              <img
                src="/assets/images/about/about-two.jpg"
                alt="About TISSA Technology"
                className="rounded-lg shadow-xl"
              />
            </div>
          </div>

          {/* Content Section */}
          <div className="lg:w-1/2 lg:pl-16">
            <div className="max-w-md">
              <span className="text-blue-600 font-medium mb-2 block">
                About Our Company
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
                7+ Years of Experience
              </h2>

              <p className="text-gray-600 mb-6">
                TISSA Technology LLC has vast expertise in mobile & custom
                applications development, providing top-tier IT services and
                business technology solutions.
              </p>

              <ul className="space-y-4 mb-8">
                <li className="flex">
                  <div className="bg-blue-100 w-10 h-7 rounded-full p-1 mr-4 mt-1">
                    <svg
                      className="w-5 h-5 text-blue-600"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <p className="text-gray-600">
                    We strive to exceed our clients' expectations by going
                    beyond traditional software development, delivering
                    innovative application solutions that transform data into
                    actionable insights and help them solve real-world
                    challenges.
                  </p>
                </li>

                <li className="flex">
                  <div className="bg-blue-100 w-10 h-7 rounded-full p-1 mr-4 mt-1">
                    <svg
                      className="w-5 h-5 text-blue-600"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <p className="text-gray-600">
                    Our vision is to become a leading software solutions
                    provider in the IT sector and continue advancing our
                    position in the market. We believe our customers' growth is
                    our growth, and we are committed to helping them achieve
                    their business goals.
                  </p>
                </li>
              </ul>

              <Link
                to="/about-us"
                className="inline-flex items-center text-blue-600 font-medium hover:text-blue-800 transition-colors"
              >
                Know More
                <svg
                  className="w-5 h-5 ml-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
